<ng-container *ngIf="state$ | async as state">
  <ng-container *ngIf="!state.stepHidden">
    <div *ngIf="state.withNumbering" class="number">
      {{ state.step }}/{{ state.allSteps }}
    </div>

    <ng-container *ngIf="state.useSections">
      <ng-container *ngIf="state.isOnboarding">
        <ng-container *ngIf="!state.useSeparateSections">
          <div *ngIf="state.allSteps" class="steps">
            <div class="sections">
              <svg *ngIf="!state.sectionsWithCheckmarks; else firstCheckmark" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="5" fill="white" stroke="#0265DC" stroke-width="2"/>
              </svg>
              <ng-template #firstCheckmark>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="8" cy="8" r="8" fill="#0265DC"/>
                  <g clip-path="url(#clip0_18380_44139)">
                  <path d="M5.37502 8L7.12502 9.75L10.625 6.25M13.8334 8C13.8334 11.2217 11.2217 13.8333 8.00002 13.8333C4.77836 13.8333 2.16669 11.2217 2.16669 8C2.16669 4.77834 4.77836 2.16667 8.00002 2.16667C11.2217 2.16667 13.8334 4.77834 13.8334 8Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_18380_44139">
                  <rect width="14" height="14" fill="white" transform="translate(1 1)"/>
                  </clipPath>
                  </defs>
                </svg>
              </ng-template>
              <div *ngFor="let section of state.onboardingSections; index as i" class="section" [style.width.%]="1 / state.onboardingSections.length * 100">
                <div class="section__progress">
                  <div class="section__completed" [style.width.%]="i | sectionProgress:state"></div>
                </div>
                
                <svg *ngIf="!state.sectionsWithCheckmarks; else checkmarks" [class.ready]="i | sectionDone:state" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6" cy="6" r="5" fill="white" stroke="#C8CDD2" stroke-width="2"/>
                </svg>
                <ng-template #checkmarks>
                  <div class="checkmark" [class.checkmark--done]="i | sectionDone:state">
                    <svg class="complete" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="8" fill="#0265DC"/>
                      <g clip-path="url(#clip0_18380_44139)">
                      <path d="M5.37502 8L7.12502 9.75L10.625 6.25M13.8334 8C13.8334 11.2217 11.2217 13.8333 8.00002 13.8333C4.77836 13.8333 2.16669 11.2217 2.16669 8C2.16669 4.77834 4.77836 2.16667 8.00002 2.16667C11.2217 2.16667 13.8334 4.77834 13.8334 8Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_18380_44139">
                      <rect width="14" height="14" fill="white" transform="translate(1 1)"/>
                      </clipPath>
                      </defs>
                    </svg>
                    <svg class="incomplete" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle cx="8" cy="8" r="7" fill="white" stroke="#C8CDD2" stroke-width="2"/>
                    </svg>
                  </div>
                </ng-template>
              </div>
            </div>
            
          </div>
          <div *ngIf="state.allSteps" class="title">
            {{ displayedSection | translate }}
          </div>
        </ng-container>
        
        <ng-container *ngIf="state.useSeparateSections">
          <div *ngIf="state.allSteps" class="steps-separate">
            <div class="sections">
              <div *ngFor="let section of state.onboardingSections; index as i" class="section section--separate" [style.width.%]="1 / state.onboardingSections.length * 100">
                <div class="section__progress section__progress--separate">
                  <div class="section__completed section__completed--separate" [style.width.%]="i | sectionProgress:state"></div>
                </div>
              </div>
            </div>
            <div *ngIf="state.allSteps" class="info">
              <div class="info__name">
                {{ displayedSection | translate }}
              </div>
              <div class="info__progress">
                {{ state | sectionStepProgress | translate }}
              </div>
            </div>
          </div>
          
        </ng-container>
      </ng-container>
    </ng-container>
    

    <ng-container *ngIf="!state.useSections">
      <div *ngIf="state.allSteps" class="steps">
        <div class="loading">
          <div class="completed" [style.width.%]="(state.step) / (state.allSteps) * 100"></div>
        </div>
      </div>
    </ng-container>
    
  </ng-container>
  
</ng-container>

